;(function () {
  'use strict'

  class InlineQuickView {
    constructor() {
      this.init()
    }

    init() {
      // Initialize when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initializeAllQuickViews())
      } else {
        this.initializeAllQuickViews()
      }
    }

    initializeAllQuickViews() {
      // Find all product forms with variant pickers
      const productForms = document.querySelectorAll('product-form .variant-picker')

      productForms.forEach((variantPicker) => {
        this.initializeVariantPicker(variantPicker)
      })
    }

    initializeVariantPicker(variantPicker) {
      const productForm = variantPicker.closest('product-form')
      const productCard = productForm.closest('.product-card')
      const productId = productCard.getAttribute('data-product-id')

      console.log('Initializing variant picker for product:', productId)

      // Set initial button state with default variant price
      this.setInitialButtonState(productForm, productCard)

      // Initialize subscription UI if present
      this.initializeSubscription(productCard, productForm)

      // Listen for variant changes
      variantPicker.addEventListener('change', (e) => {
        this.handleVariantChange(e, productForm)
      })

      // Listen for clicks on variant options
      const variantOptions = variantPicker.querySelectorAll(
        'input[type="radio"], .variant-picker__option-button'
      )
      variantOptions.forEach((option) => {
        option.addEventListener('click', (e) => {
          setTimeout(() => {
            this.handleVariantChange(e, productForm)
          }, 10)
        })
      })
    }

    initializeSubscription(productCard, productForm) {
      const hiddenSellingPlan = productForm.querySelector('input[name="selling_plan"]')
      const addToCartButton = productForm.querySelector('button[name="add"]')
      const buttonText = addToCartButton
        ? addToCartButton.querySelector('.product-card__atc-text')
        : null

      if (!hiddenSellingPlan || !buttonText) return

      // Get first selling plan ID
      const sellingPlansScript = productCard.querySelector(
        'script[type="application/json"][data-selling-plans]'
      )
      let firstSellingPlanId = null

      try {
        const sellingPlanGroups = sellingPlansScript
          ? JSON.parse(sellingPlansScript.textContent)
          : []
        if (sellingPlanGroups.length > 0 && sellingPlanGroups[0].selling_plans.length > 0) {
          firstSellingPlanId = sellingPlanGroups[0].selling_plans[0].id
        }
      } catch (e) {}

      // Auto-enable subscription if selling plans are available
      if (firstSellingPlanId) {
        hiddenSellingPlan.value = firstSellingPlanId
        // Button text will be updated by refreshButtonPriceForSelection
      } else {
        hiddenSellingPlan.value = ''
        buttonText.textContent = 'Add to cart'
      }

      // Update button price
      this.refreshButtonPriceForSelection(productCard, productForm)
    }

    refreshButtonPriceForSelection(productCard, productForm) {
      // get current variant id from hidden input
      const variantIdInput = productForm.querySelector('input[name="id"]')
      const variantId = variantIdInput ? parseInt(variantIdInput.value) : null
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]')
      const selectedSellingPlanId =
        sellingPlanInput && sellingPlanInput.value ? parseInt(sellingPlanInput.value) : null

      const variants = this.getVariantData(productCard) || []
      const variant = variants.find((v) => v.id === variantId)
      if (!variant) return

      // If a selling plan is selected, try to find allocation price
      let priceCents = variant.price
      let originalPriceCents = variant.price
      const allVariantsScript = productCard.querySelector(
        'script[type="application/json"][data-all-variants]'
      )
      try {
        const fullVariants = allVariantsScript ? JSON.parse(allVariantsScript.textContent) : []
        const fullVariant = fullVariants.find((v) => v.id === variantId)
        if (
          fullVariant &&
          selectedSellingPlanId &&
          Array.isArray(fullVariant.selling_plan_allocations)
        ) {
          const allocation = fullVariant.selling_plan_allocations.find(
            (a) => a.selling_plan_id === selectedSellingPlanId
          )
          if (allocation && allocation.price) {
            priceCents = allocation.price
            originalPriceCents = fullVariant.price
          }
        }
      } catch (e) {}

      // Update button
      const addToCartButton = productForm.querySelector('button[name="add"]')
      const buttonText = addToCartButton && addToCartButton.querySelector('.product-card__atc-text')
      if (addToCartButton && buttonText) {
        const price = priceCents ? (priceCents / 100).toFixed(2) : '0.00'
        const currencySymbol = '$'

        // Show subscription price with original price crossed out in button
        if (selectedSellingPlanId) {
          const originalPrice = originalPriceCents ? (originalPriceCents / 100).toFixed(2) : '0.00'
          buttonText.innerHTML = `${currencySymbol}${price} <span style="text-decoration: line-through; opacity: 0.7; margin-left: 2px;">${currencySymbol}${originalPrice}</span> | Subscribe`
        } else {
          buttonText.textContent = `${currencySymbol}${price} | Add to cart`
        }
      }
    }

    handleVariantChange(event, productForm) {
      const variantPicker = event.target.closest('.variant-picker')
      const productCard = productForm.closest('.product-card')
      const productId = productCard.getAttribute('data-product-id')

      console.log('Processing variant change for product:', productId)

      // Get selected options
      const selectedOptions = this.getSelectedOptions(variantPicker)
      console.log('Selected options:', selectedOptions)

      // Get variant data
      const variantData = this.getVariantData(productCard)
      console.log('Variant data:', variantData)

      if (variantData && selectedOptions.length > 0) {
        // Find matching variant
        const selectedVariant = variantData.find((variant) => {
          return selectedOptions.every((option, index) => {
            const variantOption = variant.options?.[index] || variant[`option${index + 1}`]
            return variantOption === option
          })
        })

        console.log('Matched variant:', selectedVariant)

        if (selectedVariant) {
          // Update hidden input
          const hiddenInput = productForm.querySelector('input[name="id"]')
          if (hiddenInput) {
            hiddenInput.value = selectedVariant.id
            console.log('Updated hidden input with variant ID:', selectedVariant.id)
          }

          // Update add to cart button with price
          this.updateAddToCartButton(productForm, selectedVariant)
        }
      }
    }

    getSelectedOptions(variantPicker) {
      const selectedOptions = []

      // Find all checked radio buttons within this variant picker
      const checkedRadios = variantPicker.querySelectorAll('input[type="radio"]:checked')

      checkedRadios.forEach((radio, index) => {
        selectedOptions[index] = radio.value
        console.log(`Option ${index} selected:`, radio.value)
      })

      return selectedOptions
    }

    getVariantData(productCard) {
      // Try to get variant data from script tag
      const allVariantsScript = productCard.querySelector(
        'script[type="application/json"][data-all-variants]'
      )
      if (allVariantsScript) {
        try {
          const variantData = JSON.parse(allVariantsScript.textContent)
          return variantData.map((variant) => ({
            id: variant.id,
            available: variant.available,
            price: variant.price,
            compare_at_price: variant.compare_at_price,
            options:
              variant.options ||
              [variant.option1, variant.option2, variant.option3].filter(Boolean),
          }))
        } catch (e) {
          console.warn('Failed to parse variant data')
        }
      }
      return null
    }

    setInitialButtonState(productForm, productCard) {
      // Get the default/selected variant
      const hiddenInput = productForm.querySelector('input[name="id"]')
      if (!hiddenInput) return

      const defaultVariantId = parseInt(hiddenInput.value)
      const variantData = this.getVariantData(productCard)

      if (variantData) {
        // Find the default variant
        const defaultVariant = variantData.find((variant) => variant.id === defaultVariantId)

        if (defaultVariant) {
          console.log('Setting initial button state with default variant:', defaultVariant)
          this.updateAddToCartButton(productForm, defaultVariant)
        }
      }
    }

    updateAddToCartButton(productForm, variant) {
      const addToCartButton = productForm.querySelector('button[name="add"]')
      const buttonText = addToCartButton.querySelector('.product-card__atc-text')
      const productCard = productForm.closest('.product-card')

      console.log('Variant data for button update:', variant)

      if (variant && variant.available) {
        addToCartButton.disabled = false

        // Use the same logic as refreshButtonPriceForSelection to maintain subscription state
        this.refreshButtonPriceForSelection(productCard, productForm)
      } else {
        addToCartButton.disabled = true
        buttonText.textContent = 'Sold out'
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new InlineQuickView()
    })
  } else {
    new InlineQuickView()
  }

  // Make it globally available
  window.InlineQuickView = InlineQuickView
})()
